import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useBrowserPageTitle } from "../../components/BrowserPageTitle/BrowserPageTitle";
import { RouteBackgroundChecksToComplete } from "./routes/BackgroundChecksToComplete";
import { RouteDocumentsToSign } from "./routes/RouteDocumentsToSign";
import { RouteFilesToShare } from "./routes/RouteFilesToShare";
import { RouteIdentityVerification } from "./routes/RouteIdentityVerification";
import { RouteIndex } from "./routes/RouteIndex";
import {
  DASHBOARD_PAYEE_REQUIREMENT_DETAILS_PATH,
  RoutePayeeRequirementDetails
} from "./routes/RouteRequirementDetails/RoutePayeeRequirementDetails";
import {
  DASHBOARD_PAYER_REQUIREMENTS_ROOT_PATH,
  RoutePayerRequirementDetails
} from "./routes/RouteRequirementDetails/RoutePayerRequirementDetails";
import { RoutePendingReviewRequirements } from "./routes/RouteRequirementsToApprove";
import { RouteW9Consent } from "./routes/RouteW9Consent";
import { RouteInsuranceCoverageToMonitor } from "./routes/InsuranceCoverageToMonitor";

export const DashboardIndex: React.FC = () => {
  useBrowserPageTitle("Dashboard");

  return (
    <Switch>
      <Route
        path="/member/dashboard/contractor-background-checks"
        render={() => <RouteBackgroundChecksToComplete />}
        exact
      />
      <Route
        path="/member/dashboard/contractor-files-sharing"
        render={() => <RouteFilesToShare />}
        exact
      />
      <Route
        path="/member/dashboard/contractor-insurance-coverages"
        render={() => <RouteInsuranceCoverageToMonitor />}
        exact
      />
      <Route
        path="/member/dashboard/contractor-identity-verification"
        render={() => <RouteIdentityVerification />}
        exact
      />
      <Route
        path="/member/dashboard/collaborators-e-signatures"
        render={() => <RouteDocumentsToSign type="collaborator" />}
        exact
      />
      <Route
        path="/member/dashboard/clients-e-signatures"
        render={() => <RouteDocumentsToSign type="client" />}
        exact
      />
      <Route
        path={DASHBOARD_PAYER_REQUIREMENTS_ROOT_PATH}
        component={RoutePayerRequirementDetails}
        exact
      />
      <Route
        path={DASHBOARD_PAYEE_REQUIREMENT_DETAILS_PATH}
        component={RoutePayeeRequirementDetails}
        exact
      />

      <Route
        path="/member/dashboard/client-pending-review"
        component={RoutePendingReviewRequirements}
        exact
      />

      <Route
        path="/member/dashboard/w9-consent"
        component={RouteW9Consent}
        exact
      />
      <Route path="/member/dashboard" component={RouteIndex} />
      <Redirect from="*" to="/member/dashboard" />
    </Switch>
  );
};
